// Local (the data comes from the local database):
// export const RootAPIURL = 'http://localhost:8000/api/v1/';

// Production (the data comes from the production database on the server):
export const RootAPIURL = "https://esltalks.pythonanywhere.com/api/v1/";
